import Component, { QUERY } from 'components/pages/OfferLandingPage/OfferLandingPage';
import { buildPage, buildQueryPreloader, buildRelayEnvironment } from 'utils/pageHelper';
import { GetStaticPaths } from 'next/types';
import { fetchQuery } from 'react-relay';
import { ALL_DEALS_OFFERS_QUERY } from 'relay/queries/AllDealsOffersQuery';
import { AllDealsOffersQuery } from 'relay/queries/__generated__/AllDealsOffersQuery.graphql';

type DealType = {
  params: {
    offerGuid: string;
  };
  locale: string;
};

export default buildPage(Component, {
  withNestedMetaData: true,
});

export const getStaticPaths: GetStaticPaths = async function getStaticPaths({ locales }) {
  let deals: DealType[] = [];

  for (const locale of locales!) {
    const environment = buildRelayEnvironment(locale);
    const res = await fetchQuery<AllDealsOffersQuery>(
      environment,
      ALL_DEALS_OFFERS_QUERY,
      {},
    ).toPromise();

    const mappedDealOffers: DealType[] | undefined = res?.deals?.edges.map((deal) => {
      return { params: { offerGuid: deal.node.guid }, locale: deal.node.locales[0] };
    });

    mappedDealOffers && deals.push(...mappedDealOffers);
  }

  return {
    paths: deals, // Duplicate offers are automatically removed in the Next.js build
    fallback: 'blocking',
  };
};

export const getStaticProps = buildQueryPreloader(QUERY, (context) => ({
  input: { offerGuid: context.params?.offerGuid || 'undefined' },
}));
